import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function CancelIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-cancel-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.24 20l6.17-6.17c.79-.79.79-2.08 0-2.88l-.36-.36c-.79-.79-2.08-.79-2.88 0L20 16.76l-6.17-6.17c-.79-.79-2.08-.79-2.88 0l-.36.36c-.79.79-.79 2.08 0 2.88L16.76 20l-6.17 6.17c-.79.79-.79 2.08 0 2.88l.36.36c.79.79 2.08.79 2.88 0L20 23.24l6.17 6.17c.79.79 2.08.79 2.88 0l.36-.36c.79-.79.79-2.08 0-2.88L23.24 20z"
  })));
}